<template>
	<!-- 只有当 message 存在才显示 -->
	<div v-if="message" class="mini-capsule slide-in-right" @click="handleWatch">
		<!-- 装饰：微弱的背景光晕 -->
		<div class="glow-bg"></div>

		<div class="capsule-body">
			<!-- 1. 动态图标 -->
			<div class="icon-wrap">
				<fa-icon icon="bell" class="bell-icon" />
				<!-- 红点状态 -->
				<span class="status-dot"></span>
			</div>

			<!-- 2. 精简文本：只显示标题 -->
			<div class="text-wrap">
				<div class="info-row">
					<span class="new-tag">NEW</span>
					<span class="time1">{{ formatTimeShort(message.time) }}</span>
				</div>
				<h4 class="title1">{{ message.title }}</h4>
			</div>

			<!-- 3. 关闭按钮 (极小) -->
			<button class="close-btn" @click.stop="handleRemind">
				<fa-icon icon="times" />
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LatestMessageMini',
	data() {
		return {
			message: null,
		};
	},
	created() {
		this.fetchLatestMessage();
	},
	methods: {
		// 极简时间：只显示 "12:30" 或 "10-24"
		formatTimeShort(timeStr) {
			if (!timeStr) return '';
            return timeStr.split('T')[0];
			// 如果包含T，例如 2023-10-12T14:30:00，取 14:30
			if (timeStr.includes('T') || timeStr.includes(':')) {
				const date = new Date(timeStr.replace('T', ' '));
				// 如果是今天，显示时间，否则显示日期
				return `${date.getHours()}:${date.getMinutes().toString().padStart(2, '0')}`;
			}
			return timeStr; // 比如 "2分钟前"
		},
		async fetchLatestMessage() {
			try {
				const fd = new FormData();
				fd.append('InputJson', JSON.stringify({ Key: '',Status:'1' }));
				fd.append('PageIndex', 1);
				fd.append('PageSize', 1);

				const res = await this.$api.beyoudsky.GetMessageFileList(fd);
				if (res.data.errorCode == '1') {
					const { Data = [] } = res.data.data;
					if (Data.length > 0) {
						this.message = {
							id: Data[0].id,
							title: Data[0].title,
							// description 被省略，节省空间
							time: Data[0].createdTime,
						};
					}
				}
			} catch (error) {
				console.error('获取消息失败:', error);
			}
		},
		handleWatch() {
			// 点击胶囊跳转
			this.$router.push({ name: 'MessageNews', params: { id: this.message.id } });
		},
		handleRemind() {
			// 关闭
			this.message = null;
		},
	},
};
</script>

<style lang="less" scoped>
// --- 变量配置 ---
@pill-height: 48px;
@color-bg: rgba(15, 23, 42, 0.85); // 深蓝黑背景
@color-highlight: #ec4899; // 粉色高亮
@text-white: #ffffff;
@text-sub: #94a3b8;

// --- 进场动画：从右侧滑入 ---
@keyframes slideInRight {
	from {
		opacity: 0;
		transform: translateX(20px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes swing {
	0%, 100% { transform: rotate(0deg); }
	20% { transform: rotate(15deg); }
	40% { transform: rotate(-10deg); }
	60% { transform: rotate(5deg); }
	80% { transform: rotate(-5deg); }
}

.mini-capsule {
	// --- 定位：右下角悬浮 ---
	// position: fixed;
	// right: 16px; 
	// right: 8px; 
	// bottom: 15vh; // 避开移动端底部导航栏高度，大概距底15%
    // top: 25vh;
	z-index: 1000;

	// --- 尺寸限制 ---
	height: @pill-height;
	max-width: 85vw; // 宽度限制，保持小巧
    width: fit-content;
	
	// --- 外观 ---
	background: @color-bg;
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
	border: 1px solid rgba(255, 255, 255, 0.15);
	border-radius: 999px; // 全圆角/胶囊形
	box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);

	// --- 交互 ---
	cursor: pointer;
	user-select: none;
	overflow: hidden; // 裁剪光晕

	&.slide-in-right {
		animation: slideInRight 0.4s cubic-bezier(0.18, 0.89, 0.32, 1.28) forwards;
	}

	// 极微弱的背景光晕
	.glow-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 50%;
		height: 100%;
		background: radial-gradient(circle at 0% 50%, rgba(236, 72, 153, 0.2), transparent 70%);
		z-index: 0;
	}
}

.capsule-body {
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	height: 100%;
	padding: 0 10px 0 4px; // 左紧右松
}

// 1. 图标区域
.icon-wrap {
	width: 36px;
	height: 36px;
	flex-shrink: 0;
	border-radius: 50%;
	background: linear-gradient(135deg, #ec4899, #8b5cf6);
	display: flex;
	align-items: center;
	justify-content: center;
	color: @text-white;
	margin-right: 8px;
	position: relative;

	.bell-icon {
		font-size: 14px;
		animation: swing 3s infinite ease-in-out;
	}
	
	// 红点
	.status-dot {
		position: absolute;
		top: 0;
		right: 0;
		width: 8px;
		height: 8px;
		background: #ef4444;
		border: 1.5px solid @color-bg;
		border-radius: 50%;
	}
}

// 2. 文本区域
.text-wrap {
	flex: 1;
	min-width: 0; // 允许 flex item 缩小以显示省略号
    // width: fit-content;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-right: 8px;

	.info-row {
		display: flex;
		align-items: center;
		gap: 6px;
		line-height: 1;
		margin-bottom: 2px;
        // word-break: break-all;

		.new-tag {
			font-size: 8px;
			font-weight: 800;
			color: #fce7f3;
			background: rgba(236, 72, 153, 0.4);
			padding: 1px 3px;
			border-radius: 3px;
		}

		.time1 {
			font-size: 9px;
			color: @text-sub;
		}
	}

	.title1 {
		margin: 0;
		font-size: 12px;
		color: @text-white;
		font-weight: 500;
		
		// 单行省略
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}

// 3. 关闭按钮
.close-btn {
	flex-shrink: 0;
	background: rgba(255,255,255,0.1);
	border: none;
	width: 18px;
	height: 18px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: rgba(255,255,255,0.6);
	font-size: 10px;
	cursor: pointer;
	
	// 绝对定位微调，为了不占用文本空间
	position: absolute;
	top: -4px;
	right: 0;
	// 或者直接放在流中
	position: static;

	&:active {
		background: rgba(255,255,255,0.3);
		color: #fff;
	}
}
</style>
